import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

// Resolves a legacy deep link (/jobs/:id from the old CRM Jobs, or an old BD
// campaign id) to its merged campaign in the unified model, then redirects.
// Falls back to the Campaigns index if it can't be resolved.
const LegacyCampaignRedirect: React.FC<{ source: 'crm_job' | 'bd_campaign' }> = ({ source }) => {
  const { legacyId } = useParams<{ legacyId: string }>();
  const { token } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const fallback = source === 'crm_job' ? '/campaigns?mode=delivery' : '/campaigns';
      if (!token || !legacyId) { navigate(fallback, { replace: true }); return; }
      try {
        const resp = await fetch(`/api/campaigns/legacy/${source}/${legacyId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (cancelled) return;
        if (resp.ok) {
          const data = await resp.json();
          navigate(`/campaigns/${data.id}`, { replace: true });
        } else {
          navigate(fallback, { replace: true });
        }
      } catch {
        if (!cancelled) navigate(fallback, { replace: true });
      }
    })();
    return () => { cancelled = true; };
  }, [source, legacyId, token, navigate]);

  return (
    <div className="flex items-center justify-center py-20">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
    </div>
  );
};

export default LegacyCampaignRedirect;
